export default "__VITE_ASSET__ecbb8ecd__"